import { nodeArray } from 'meteora';
import splitText from '../functions/splitText';
import inView from 'in-view';
import { tns } from "tiny-slider/src/tiny-slider";
document.addEventListener('DOMContentLoaded', function () {
  var banner = document.querySelector('.js-banner') || false;
  if (banner) {
    nodeArray(banner.querySelectorAll('.js-split-text')).forEach(function (el) {
      splitText(el);
    });
  }
  inView('.js-split-text').on('enter', function (holder) {
    return setTimeout(function () {
      holder.classList.add('in-view');
      setTimeout(function () {
        nodeArray(holder.querySelectorAll('.split')).forEach(function (item, i) {
          item.style.overflow = 'visible';
        });
      }, 300);
    }, 500);
  });
  var bannerSliders = nodeArray(document.querySelectorAll('.js-slider--banner'));
  bannerSliders.forEach(function (slider) {
    var controller = tns({
      container: slider,
      nav: false
      // controls: false,
    });
  });
});